import { render, staticRenderFns } from "./FormTransport.vue?vue&type=template&id=ae3f7b46&"
import script from "./FormTransport.vue?vue&type=script&lang=js&"
export * from "./FormTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports